module.exports = __webpack_public_path__ + "static/media/login-splash.40472b05.svg";